import { InjectionToken } from '@angular/core';
import {
  LoginReducer,
  LoginState,
} from '@modules/autenticacion/login/store/reducers';

import { Action, ActionReducerMap  } from '@ngrx/store';
interface State {
  login: LoginState;
}

export const factoryReducers = {
  factory: () => ({
    login: LoginReducer.Reducer,
  }),
};

export const ROOT_REDUCERS = new InjectionToken<
  ActionReducerMap<State, Action>
>('Root reducers token', factoryReducers);
